<div class="row  align-items-center ps-3 pe-3">
  <div class="col-12 col-sm-12 text-sm-end text-center">

  </div>


  <ng-container *ngFor="let voucher of voucherTypeList">

    <div class="col-12 col-sm-12 text-center">
      <div class="row ticket mt-2 mb-2 p-3">

        <div class="col-4 text-start">
          {{ voucher.name }}
        </div>
        <div class="col-4 text-center">

          <div class="row">
            <div class="offset-sm-3 col-12 col-sm-1 col-lg-1 px-0 me-2 col-decrement">
              <span class="increment" [ngClass]="{ 'disabled': limit === 0 || !selectedVouchers[voucher.id] }"
                    (click)="onDecrementClick(voucher)"><i class="fa fa-minus"></i></span>
            </div>
            <div class="col-12 col-sm-1 col-lg-1 px-0 sel-amount">
              <span class="count fw-bold">{{ selectedVouchers[voucher.id] ? selectedVouchers[voucher.id] : 0 }}</span>
            </div>
            <div class="col-12 col-sm-1 col-lg-1 px-0 ms-sm-2">
              <span class="increment" [ngClass]="{ 'disabled': allSelectedVoucherCount === limit }"
                    (click)="onIncrementClick(voucher)"><i class="fa fa-plus"></i></span>
            </div>
            <div class="col-12 col-sm-3 col-md-12 col-lg-3 px-0 ms-0 ms-sm-3 ms-md-0 ms-lg-3 ms-xl-0 sel-price">
              <span class="fw-bold ms-2 me-1 d-none d-lg-inline">/</span>
              <span>{{ voucher.price | number:'1.2-2' }}</span>
            </div>
          </div>



        </div>
        <div class="col-4 text-end">
          <span class="fw-bold">{{ (voucher.price * (selectedVouchers[voucher.id] || 0)) | number:'1.2-2' }}</span>
        </div>

      </div>

    </div>

  </ng-container>

</div>


